import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_KEY;
const isDevMode = process.env.REACT_APP_DEV_MODE === 'true';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Use service key in dev mode to bypass RLS issues, anon key in production
const keyToUse = isDevMode && supabaseServiceKey ? supabaseServiceKey : supabaseAnonKey;

console.log('Supabase config:', {
  url: supabaseUrl,
  devMode: isDevMode,
  usingServiceKey: isDevMode && !!supabaseServiceKey
});

export const supabase = createClient(supabaseUrl, keyToUse, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

// Helper function untuk error handling
export const handleSupabaseError = (error) => {
  console.error('Supabase Error:', error);
  throw new Error(error.message || 'An error occurred with the database');
};
